import usePersistedKeyValueStore from './usePersistedKeyValueStore';

export type PreRedirectArgs =
    | PortalConnectPreRedirectArgs
    | StripePreRedirectArgs
    | StripeConnectedAccountRedirectArgs
    | FastenConnectPreRedirectArgs;

export type PortalConnectPreRedirectArgs = {
    type: 'portal-connect';
    profileId: string;
    endpointId: number | null;
};

export type FastenConnectPreRedirectArgs = {
    type: 'fasten-connect';
    profileId: string;
    brandId: string;
    brandName: string;
    platformType: string;
};

export type StripePreRedirectArgs = {
    type: 'stripe';
};

export type StripeConnectedAccountRedirectArgs = {
    type: 'stripe-connected-account';
};

export type UsePreRedirectReturnValue = {
    isLoading: boolean;
    preRedirectArgs: PreRedirectArgs | null;
    setPreRedirectArgs: (preRedirectArgs: PreRedirectArgs, afterDelay?: () => void) => void;
    clearPreRedirectArgs: (afterDelay?: () => void) => void;
};

export default function usePreRedirectArgs(): UsePreRedirectReturnValue {
    const { isLoading, value, setValue } = usePersistedKeyValueStore<PreRedirectArgs | null>({
        category: 'pre-redirect-args',
        key: 'pre-redirect-args',
        defaultValue: null,
    });

    const setPreRedirectArgs = (preRedirectArgs: PreRedirectArgs, afterDelay?: () => void) => {
        setValue(preRedirectArgs);
        if (afterDelay) {
            setTimeout(() => {
                afterDelay();
            }, 200);
        }
    };

    const clearPreRedirectArgs = (afterDelay?: () => void) => {
        setValue(null);
        if (afterDelay) {
            setTimeout(() => {
                afterDelay();
            }, 200);
        }
    };

    return {
        isLoading,
        preRedirectArgs: value,
        setPreRedirectArgs,
        clearPreRedirectArgs,
    };
}
